export const PREVIOUS_MONOLITH_ACTIONS_COOKIE = 'trackNav';
